import React from "react";
import {
  MimaButton,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { Formik } from "formik";
import useAddTheme from "./useLogic/useAddTheme";

const AddThemeModal = ({ closeModal }) => {
  const { loading, onSubmit, validationSchema } = useAddTheme(closeModal);

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={3}>
        Add New Theme
      </MimaText>
      <Formik
        initialValues={{
          name: "",
          description: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaInput
              labelTitle="Theme Name"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
              placeholder="Enter Theme Name"
              mb={2}
            />

            <MimaTextArea
              labelTitle="Theme Description"
              name="description"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.description}
              touched={touched.description}
              placeholder="Enter Theme Description"
            />

            <MimaButton
              title="Create New Theme"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default AddThemeModal;
